var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecycleAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.25C9.92893 1.25 8.25 2.92893 8.25 5H4.5C3.67157 5 3 5.67157 3 6.5C3 7.32843 3.67157 8 4.5 8H19.5C20.3284 8 21 7.32843 21 6.5C21 5.67157 20.3284 5 19.5 5H15.75C15.75 2.92893 14.0711 1.25 12 1.25ZM12 2.75C13.2426 2.75 14.25 3.75736 14.25 5H9.75C9.75 3.75736 10.7574 2.75 12 2.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 20V9.5H19V20C19 21.1046 18.1046 22 17 22H7C5.89543 22 5 21.1046 5 20ZM9.74809 11.9466C9.71858 11.5334 9.35973 11.2224 8.94656 11.2519C8.5334 11.2814 8.22239 11.6403 8.25191 12.0534L8.75191 19.0534C8.78142 19.4666 9.14027 19.7776 9.55344 19.7481C9.9666 19.7186 10.2776 19.3597 10.2481 18.9466L9.74809 11.9466ZM15.0534 11.2519C14.6403 11.2224 14.2814 11.5334 14.2519 11.9466L13.7519 18.9466C13.7224 19.3597 14.0334 19.7186 14.4466 19.7481C14.8597 19.7776 15.2186 19.4666 15.2481 19.0534L15.7481 12.0534C15.7776 11.6403 15.4666 11.2814 15.0534 11.2519Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecycleAlt);
export default __webpack_public_path__ + "static/media/recycle-alt.1261b8c27851beed6a4fe2b154d12de2.svg";
export { ForwardRef as ReactComponent };